import { api } from 'utility';
import { getGuildServiceUrl } from 'URLs';
export function getGuildsList(obj) {
  const params = { ...obj };
  return api.get(getGuildServiceUrl(), { params }).then((res) => res.data);
}

export default { getGuildsList };
